import Core from "@/modules/core/service/Core";
import Inspection from "@/modules/dis/service/inspection/Inspection";
import Common from "@/modules/dis/service/order/private/Common";

const url = {
    assign     : "/api/disposition/order/{0}/unit/{1}",
    assignAll  : "/api/disposition/order/{0}/unit",
}

const assign  = function (order, unit, dispatcher) {
    const assignUrl = dispatcher ? url.assign + "?dispatcher=" + dispatcher.id : url.assign;
    return Core.method.post(assignUrl, null, order.id, unit.id);
}

const assignAll = function (order, location, dispatcher) {
    const assignUrl = dispatcher ? url.assignAll + "?dispatcher=" + dispatcher.id : url.assignAll;
    return Core.method.post(assignUrl, location, order.id);
}

export default {
    /**
     * Assigns the given unit to the given order.
     *
     * @param component the calling VUE component
     * @param order the order to which the unit should be assigned
     * @param location the units location
     * @param unit the unit to be assigned to the order
     * @param user the user to whom the inspection should be assigned (optional)
     * @param assignments the list of inspections currently assigned to the order
     */
    unit (component, order, location, unit, user, assignments) {
        return assign(order, unit, user).then(inspection => {
            Common.publishAssignments(
                component,
                order,
                location,
                [ Inspection.toAssignment(inspection) ],
                assignments
            );

            Core.message.hint(component, component.$t("disposition.inspection.assigned", [ unit.fabricNo ]));
            return Promise.resolve(inspection);
        }).catch(error => {
            unit.order = null;
            Core.message.popup(component, error.id, error.parameter);
        })
    },

    /**
     * Assigns all units belonging to the specified location to the given order.
     *
     * @param component the calling VUE component
     * @param location the location (zip, city and street)
     * @param order the order to which the units should be assigned
     * @param dispatcher the user to whom the inspections should be assigned (optional)
     * @param assignments the list of inspections currently assigned to the order
     *
     * @return
     */
    location (component, location, order, dispatcher, assignments) {
        const query = component.$t("disposition.inspection.assignAll.query");
        const text  = component.$t("disposition.inspection.assignAll.text", [
            location.zip,
            location.city,
            location.street,
            location.contact,
            order.no
        ]);

        return Core.message.confirm(component, query, text, Core.message.Default, (confirmed) => {
            if (!confirmed) {
                return;
            }

            Core.loading(component, true)
            location.customerId = order.customer.id;

            return assignAll(order, location, dispatcher).then(inspections => {
                if (location.units) {
                    location.units.forEach (u => u.order = order)
                }
                Common.publishAssignments(
                    component,
                    order,
                    location,
                    inspections.map(inspection => Inspection.toAssignment(inspection)),
                    assignments
                );

                Core.message.hint(component, component.$t("disposition.inspection.assignAll.success"));
                Core.loading(component, false);
            });
        });
    },
}